
import createIcon from "./createIcon";

export const ArrowLeftIcon = createIcon('ArrowLeft', (props) => {
  return (
    <svg {...props} viewBox="0 0 24 24">
      <g>
        <g>
          <path d="M18.45142,12L11.57631,19.7345L14.42369,22.2655L23.5486,12L14.42369,1.7345L11.57631,4.2655L18.45142,12Z" fillRule="evenodd" fill={props.color} fillOpacity="1" />
        </g>
        <g transform="matrix(-1,0,0,-1,38,20)">
          <line x1="19" y1="8.095170497894287" x2="37" y2="8.095170497894287" fillOpacity="0" strokeOpacity="1" stroke={props.color} fill="none" strokeWidth="3.809659004211426" />
        </g>
      </g>
    </svg >
  )
});
